import './fonts'
import './browser-detection'
